import PessoaFisica from './componentes/PessoaFisica.vue';
import Alterar from './componentes/Alterar.vue';

export default {
  path: 'web-pessoa-fisica',
  component: PessoaFisica,
  meta: { auth: true },
  children: [
    {
      path: 'alterar',
      name: 'web-pessoa-fisica.alterar',
      component: Alterar,
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/web-pessoa-fisica/rotas.js